var rt = Object.defineProperty;
var ot = (i, t, a) => t in i ? rt(i, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : i[t] = a;
var g = (i, t, a) => (ot(i, typeof t != "symbol" ? t + "" : t, a), a);
var Q, E = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, C = function(i) {
  if (document.readyState === "loading")
    return "loading";
  var t = E();
  if (t) {
    if (i < t.domInteractive)
      return "loading";
    if (t.domContentLoadedEventStart === 0 || i < t.domContentLoadedEventStart)
      return "dom-interactive";
    if (t.domComplete === 0 || i < t.domComplete)
      return "dom-content-loaded";
  }
  return "complete";
}, st = function(i) {
  var t = i.nodeName;
  return i.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, z = function(i, t) {
  var a = "";
  try {
    for (; i && i.nodeType !== 9; ) {
      var e = i, n = e.id ? "#" + e.id : st(e) + (e.classList && e.classList.value && e.classList.value.trim() && e.classList.value.trim().length ? "." + e.classList.value.trim().replace(/\s+/g, ".") : "");
      if (a.length + n.length > (t || 100) - 1)
        return a || n;
      if (a = a ? n + ">" + a : n, e.id)
        break;
      i = e.parentNode;
    }
  } catch {
  }
  return a;
}, K = -1, X = function() {
  return K;
}, M = function(i) {
  addEventListener("pageshow", function(t) {
    t.persisted && (K = t.timeStamp, i(t));
  }, !0);
}, A = function() {
  var i = E();
  return i && i.activationStart || 0;
}, y = function(i, t, a, e) {
  var n = E(), r = "navigate";
  return a ? r = a : X() >= 0 ? r = "back-forward-cache" : n && (document.prerendering || A() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), { name: i, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: r, navigationId: e || 1 };
}, L = function(i) {
  return PerformanceObserver.supportedEntryTypes.includes("soft-navigation") && (i == null ? void 0 : i.reportSoftNavs);
}, R = function(i) {
  return i && i !== 1 ? window.performance && performance.getEntriesByType && performance.getEntriesByType("soft-navigation")[i - 2] : window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, _ = function(i, t, a) {
  var e = L(a);
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(i)) {
      var n = new PerformanceObserver(function(r) {
        Promise.resolve().then(function() {
          t(r.getEntries());
        });
      });
      return n.observe(Object.assign({ type: i, buffered: !0, includeSoftNavigationObservations: e }, a || {})), n;
    }
  } catch {
  }
}, T = function(i, t, a, e) {
  var n, r;
  return function(s) {
    t.value >= 0 && (s || e) && ((r = t.value - (n || 0)) || n === void 0) && (n = t.value, t.delta = r, t.rating = function(u, o) {
      return u > o[1] ? "poor" : u > o[0] ? "needs-improvement" : "good";
    }(t.value, a), i(t));
  };
}, F = function(i) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return i();
    });
  });
}, O = function(i) {
  var t = function(a) {
    a.type !== "pagehide" && document.visibilityState !== "hidden" || i(a);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, S = -1, U = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, P = function(i) {
  document.visibilityState === "hidden" && S > -1 && (S = i.type === "visibilitychange" ? i.timeStamp : 0, ut());
}, j = function() {
  addEventListener("visibilitychange", P, !0), addEventListener("prerenderingchange", P, !0);
}, ut = function() {
  removeEventListener("visibilitychange", P, !0), removeEventListener("prerenderingchange", P, !0);
}, Y = function() {
  return S < 0 && (S = U(), j(), M(function() {
    setTimeout(function() {
      S = U(), j();
    }, 0);
  })), { get firstHiddenTime() {
    return S;
  } };
}, N = function(i) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return i();
  }, !0) : i();
}, x = [1800, 3e3], tt = function(i, t) {
  var a = L(t = t || {});
  N(function() {
    var e, n = Y(), r = y("FCP"), s = _("paint", function(u) {
      u.forEach(function(o) {
        if (o.name === "first-contentful-paint") {
          a ? (o.navigationId || 1) > 1 && (p = "soft-navigation", v = o.navigationId, r = y("FCP", 0, p, v), e = T(i, r, x, t.reportAllChanges)) : s.disconnect();
          var d = 0;
          if (o.navigationId && o.navigationId !== 1) {
            var l = R(o.navigationId), c = (l == null ? void 0 : l.startTime) || 0;
            d = Math.max(o.startTime - c, 0);
          } else
            d = Math.max(o.startTime - A(), 0);
          (o.startTime < n.firstHiddenTime || o.navigationId && o.navigationId > 1) && (r.value = d, r.entries.push(o), r.navigationId = o.navigationId || 1, e(!0));
        }
        var p, v;
      });
    }, t);
    s && (e = T(i, r, x, t.reportAllChanges), M(function(u) {
      r = y("FCP", 0, "back-forward-cache", r.navigationId), e = T(i, r, x, t.reportAllChanges), F(function() {
        r.value = performance.now() - u.timeStamp, e(!0);
      });
    }));
  });
}, q = [0.1, 0.25], ct = function(i, t) {
  (function(a, e) {
    var n, r, s = L(e = e || {}), u = !1;
    tt((n = function() {
      var o, d = y("CLS", 0), l = 0, c = [], p = function(h, m) {
        d = y("CLS", 0, h, m), o = T(a, d, q, e.reportAllChanges), l = 0, u = !1;
      }, v = function(h) {
        h.forEach(function(m) {
          if (s && m.navigationId && m.navigationId > d.navigationId && (l > d.value && (d.value = l, d.entries = c), o(!0), p("soft-navigation", m.navigationId)), !m.hadRecentInput) {
            var V = c[0], at = c[c.length - 1];
            l && m.startTime - at.startTime < 1e3 && m.startTime - V.startTime < 5e3 ? (l += m.value, c.push(m)) : (l = m.value, c = [m]);
          }
        }), l > d.value && (d.value = l, d.entries = c, o());
      }, f = _("layout-shift", v, e);
      f && (o = T(a, d, q, e.reportAllChanges), O(function() {
        v(f.takeRecords()), o(!0), u = !0;
      }), M(function() {
        p("back-forward-cache", d.navigationId), F(function() {
          return o();
        });
      }), s && _("soft-navigation", function(h) {
        h.forEach(function(m) {
          m.navigationId && m.navigationId > d.navigationId && (u || o(!0), p("soft-navigation", m.navigationId), o = T(a, d, q, e.reportAllChanges));
        });
      }, e), setTimeout(o, 0));
    }, r = !1, function(o) {
      r || (n(o), r = !0);
    }));
  })(function(a) {
    (function(e) {
      if (e.entries.length) {
        var n = e.entries.reduce(function(u, o) {
          return u && u.value > o.value ? u : o;
        });
        if (n && n.sources && n.sources.length) {
          var r = (s = n.sources).find(function(u) {
            return u.node && u.node.nodeType === 1;
          }) || s[0];
          if (r)
            return void (e.attribution = { largestShiftTarget: z(r.node), largestShiftTime: n.startTime, largestShiftValue: n.value, largestShiftSource: r, largestShiftEntry: n, loadState: C(n.startTime) });
        }
      }
      var s;
      e.attribution = {};
    })(a), i(a);
  }, t);
}, dt = function(i, t) {
  tt(function(a) {
    (function(e) {
      if (e.entries.length) {
        var n, r = e.entries[e.entries.length - 1], s = 0, u = 0;
        if (e.navigationId && e.navigationId !== 1 ? n = R(e.navigationId) : (n = E()) && (s = n.activationStart || 0, u = Math.max(0, n.responseStart - s)), n)
          return void (e.attribution = { timeToFirstByte: u, firstByteToFCP: e.value - u, loadState: C(e.entries[0].startTime), navigationEntry: n, fcpEntry: r });
      }
      e.attribution = { timeToFirstByte: 0, firstByteToFCP: e.value, loadState: C(X()) };
    })(a), i(a);
  }, t);
}, D = 0, w = 1 / 0, b = 0, W = 1, et = !1, lt = function(i) {
  i.forEach(function(t) {
    t.interactionId && (et && t.navigationId && t.navigationId > W && (W = t.navigationId, D = 0, w = 1 / 0, b = 0), w = Math.min(w, t.interactionId), b = Math.max(b, t.interactionId), D = b ? (b - w) / 7 + 1 : 0);
  });
}, nt = function() {
  return Q ? D : performance.interactionCount || 0;
}, ft = function(i) {
  "interactionCount" in performance || Q || (et = i || !1, Q = _("event", lt, { type: "event", buffered: !0, durationThreshold: 0, includeSoftNavigationObservations: i }));
}, B = [200, 500], it = 0, J = function() {
  return nt() - it;
}, I = [], $ = {}, Z = function(i) {
  var t = I[I.length - 1], a = $[i.interactionId];
  if (a || I.length < 10 || i.duration > t.latency) {
    if (a)
      a.entries.push(i), a.latency = Math.max(a.latency, i.duration);
    else {
      var e = { id: i.interactionId, latency: i.duration, entries: [i] };
      $[e.id] = e, I.push(e);
    }
    I.sort(function(n, r) {
      return r.latency - n.latency;
    }), I.splice(10).forEach(function(n) {
      delete $[n.id];
    });
  }
}, vt = function(i, t) {
  var a = L(t = t || {}), e = !1;
  N(function() {
    ft(a);
    var n, r = y("INP"), s = function(l, c) {
      I = [], it = l === "soft-navigation" ? 0 : nt(), r = y("INP", 0, l, c), n = T(i, r, B, t.reportAllChanges), e = !1;
    }, u = function() {
      var l, c, p = (c = Math.min(I.length - 1, Math.floor(J() / 50)), I[c]);
      p && (p.latency !== r.value || (l = t) !== null && l !== void 0 && l.reportAllChanges) && (r.value = p.latency, r.entries = p.entries);
    }, o = function(l) {
      l.forEach(function(c) {
        a && c.navigationId && c.navigationId > r.navigationId && (e || (u(), r.value > 0 && n(!0)), s("soft-navigation", c.navigationId)), c.interactionId && Z(c), c.entryType === "first-input" && !I.some(function(p) {
          return p.entries.some(function(v) {
            return c.duration === v.duration && c.startTime === v.startTime;
          });
        }) && Z(c);
      }), u(), n();
    }, d = _("event", o, { durationThreshold: t.durationThreshold || 40, opts: t });
    n = T(i, r, B, t.reportAllChanges), d && (d.observe({ type: "first-input", buffered: !0, includeSoftNavigationObservations: a }), O(function() {
      o(d.takeRecords()), r.value < 0 && J() > 0 && (r.value = 0, r.entries = []), n(!0);
    }), M(function() {
      s("back-forward-cache", r.navigationId), F(function() {
        return n();
      });
    }), a && _("soft-navigation", function(l) {
      l.forEach(function(c) {
        c.navigationId && c.navigationId > r.navigationId && (!e && r.value > 0 && n(!0), s("soft-navigation", c.navigationId), n = T(i, r, B, t.reportAllChanges));
      });
    }, t));
  });
}, gt = function(i, t) {
  vt(function(a) {
    (function(e) {
      if (e.entries.length) {
        var n = e.entries.sort(function(r, s) {
          return s.duration - r.duration || s.processingEnd - s.processingStart - (r.processingEnd - r.processingStart);
        })[0];
        e.attribution = { eventTarget: z(n.target), eventType: n.name, eventTime: n.startTime, eventEntry: n, loadState: C(n.startTime) };
      } else
        e.attribution = {};
    })(a), i(a);
  }, t);
}, G = [2500, 4e3], pt = function(i, t) {
  (function(a, e) {
    var n = !1, r = L(e = e || {});
    N(function() {
      var s, u = Y(), o = y("LCP"), d = function(v, f) {
        o = y("LCP", 0, v, f), s = T(a, o, G, e.reportAllChanges), n = !1;
      }, l = function(v) {
        v.forEach(function(f) {
          if (f) {
            f.navigationId && f.navigationId > o.navigationId && (n || s(!0), d("soft-navigation", f.navigationId));
            var h, m = 0;
            m = f.navigationId !== 1 && f.navigationId ? Math.max(f.startTime - (((h = R(f.navigationId)) === null || h === void 0 ? void 0 : h.startTime) || 0), 0) : Math.max(f.startTime - A(), 0), f.startTime < u.firstHiddenTime && (o.value = m, o.entries = [f], o.navigationId = f.navigationId || 1, s());
          }
        });
      }, c = function() {
        n || (l(p.takeRecords()), r || p.disconnect(), n = !0, s(!0));
      }, p = _("largest-contentful-paint", l, e);
      p && (s = T(a, o, G, e.reportAllChanges), ["keydown", "click"].forEach(function(v) {
        addEventListener(v, c, !0);
      }), O(c), M(function(v) {
        d("back-forward-cache", o.navigationId), F(function() {
          o.value = performance.now() - v.timeStamp, n = !0, s(!0);
        });
      }), r && _("soft-navigation", function(v) {
        v.forEach(function(f) {
          f.navigationId && f.navigationId > o.navigationId && (n || s(!0), d("soft-navigation", f.navigationId));
        });
      }, e));
    });
  })(function(a) {
    (function(e) {
      if (e.entries.length) {
        var n, r = 0, s = 0;
        if (e.navigationId && e.navigationId !== 1 ? n = R() : (n = E()) && (r = n.activationStart || 0, s = n.responseStart || 0), n) {
          var u = e.entries[e.entries.length - 1], o = u.url && performance.getEntriesByType("resource").filter(function(f) {
            return f.name === u.url;
          })[0], d = Math.max(0, s - r), l = Math.max(d, o ? (o.requestStart || o.startTime) - r : 0), c = Math.max(l, o ? o.responseEnd - r : 0), p = Math.max(c, u ? u.startTime - r : 0), v = { element: z(u.element), timeToFirstByte: d, resourceLoadDelay: l - d, resourceLoadTime: c - l, elementRenderDelay: p - c, navigationEntry: n, lcpEntry: u };
          return u.url && (v.url = u.url), o && (v.lcpResourceEntry = o), void (e.attribution = v);
        }
      }
      e.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: e.value };
    })(a), i(a);
  }, t);
}, k = [800, 1800], mt = function i(t) {
  document.prerendering ? N(function() {
    return i(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return i(t);
  }, !0) : setTimeout(t, 0);
}, ht = function(i, t) {
  var a = L(t = t || {}), e = y("TTFB"), n = T(i, e, k, t.reportAllChanges);
  mt(function() {
    var r = E();
    if (r) {
      var s = r.responseStart;
      if (s <= 0 || s > performance.now())
        return;
      e.value = Math.max(s - A(), 0), e.entries = [r], n(!0), M(function() {
        e = y("TTFB", 0, "back-forward-cache", e.navigationId), (n = T(i, e, k, t.reportAllChanges))(!0);
      }), a && _("soft-navigation", function(u) {
        u.forEach(function(o) {
          o.navigationId && (e = y("TTFB", 0, "soft-navigation", o.navigationId), (n = T(i, e, k, t.reportAllChanges))(!0));
        });
      }, t);
    }
  });
}, Tt = function(i, t) {
  ht(function(a) {
    (function(e) {
      if (e.entries.length) {
        var n = e.entries[0], r = n.activationStart || 0, s = Math.max(n.domainLookupStart - r, 0), u = Math.max(n.connectStart - r, 0), o = Math.max(n.requestStart - r, 0);
        e.attribution = { waitingTime: s, dnsTime: u - s, connectionTime: o - u, requestTime: e.value - o, navigationEntry: n };
      } else
        e.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
    })(a), i(a);
  }, t);
};
function yt(i) {
  return { evid: 180, src: 72, endpoint: "pulse", params: i };
}
const It = [
  // GUID
  [
    /\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\/|$)/g,
    "/:guid$1"
  ],
  // Hexa ID
  [/\/[0-9a-fA-F]{24,}(\/|$)/g, "/:id$1"],
  // Numeric ID
  [/\/[0-9]{12}(\/|$)/g, "/:id$1"],
  // Date
  [/\/[0-9]{4}-[0-9]{2}-[0-9]{2}(\/|$)/g, "/:date$1"],
  // Form submission
  [/\/comp-[a-zA-Z0-9]{8}(\/|$)/g, "/:id$1"],
  // Remove trailing slash
  [/\/$/, ""]
], _t = (i) => {
  const t = new URL(i);
  return It.forEach(([a, e]) => {
    t.pathname = t.pathname.replace(a, e);
  }), t.search = "", t.toString();
}, St = (i) => {
  var e, n;
  const { value: t, attribution: a } = i;
  return {
    clsVal: t.toString(),
    clsLargestShiftVal: (e = a.largestShiftValue) == null ? void 0 : e.toString(),
    clsLargestShiftTime: a.largestShiftTime ? Math.trunc(a.largestShiftTime) : void 0,
    clsRating: i.rating,
    metadata: {
      clsLargestShiftTarget: a.largestShiftTarget,
      clsLargestShiftSource: (n = a.largestShiftSource) == null ? void 0 : n.toString()
    }
  };
}, Et = (i, t) => {
  var r, s, u, o, d;
  const { value: a, attribution: e } = i;
  let n = {};
  if (t && ((r = e.eventEntry) != null && r.target))
    try {
      n = t(
        (s = e.eventEntry) == null ? void 0 : s.target
      );
    } catch {
    }
  return {
    inpValue: Math.trunc(a),
    inpRating: i.rating,
    inpEventType: e.eventType,
    inpStartTime: e.eventTime ? Math.trunc(e.eventTime) : void 0,
    inpProcessingStart: (u = e.eventEntry) != null && u.processingStart ? Math.trunc(e.eventEntry.processingStart) : void 0,
    inpProcessingEnd: (o = e.eventEntry) != null && o.processingEnd ? Math.trunc(e.eventEntry.processingEnd) : void 0,
    inpInteractionId: (d = e.eventEntry) == null ? void 0 : d.interactionId,
    inpLoadState: e.loadState,
    ...n.compType && {
      inpCompType: n.compType
    },
    ...n.widgetId && {
      inpWidgetId: n.widgetId
    },
    ...n.applicationId && {
      inpAppId: n.applicationId
    },
    metadata: {}
  };
}, Mt = (i, t) => {
  var d, l, c, p, v, f, h, m;
  const { value: a, attribution: e } = i, { lcpEntry: n, url: r } = e;
  let s = {};
  if (t && (n != null && n.element))
    try {
      s = t(
        n == null ? void 0 : n.element
      );
    } catch {
    }
  const u = /\.(jpe?g|png|gif|svg|webp)/i.exec(r || ""), o = ((d = u == null ? void 0 : u[1]) == null ? void 0 : d.toLowerCase().replace("jpeg", "jpg")) || "other";
  return {
    lcp: Math.trunc(a),
    lcpSize: n != null && n.size ? Math.trunc(n.size) : void 0,
    lcpTag: (l = n == null ? void 0 : n.element) == null ? void 0 : l.tagName,
    ...r && { lcpContentType: o },
    lcpResourceLoadDelay: Math.trunc(e.resourceLoadDelay),
    lcpResourceLoadTime: Math.trunc(e.resourceLoadTime),
    lcpElementRenderDelay: Math.trunc(e.elementRenderDelay),
    ...r && { lcpUrl: r },
    lcpInitiatorType: (c = e.lcpResourceEntry) == null ? void 0 : c.initiatorType,
    ...s.compType && {
      lcpCompType: s.compType
    },
    ...s.widgetId && {
      lcpWidgetId: s.widgetId
    },
    ...s.applicationId && {
      lcpAppId: s.applicationId
    },
    metadata: {
      lcpResourceRequestStart: (p = e.lcpResourceEntry) == null ? void 0 : p.requestStart,
      lcpResourceResponseStart: (v = e.lcpResourceEntry) == null ? void 0 : v.responseStart,
      lcpResourceTransferSize: (f = e.lcpResourceEntry) == null ? void 0 : f.transferSize,
      lcpResourceNetworkProtocol: (h = e.lcpResourceEntry) == null ? void 0 : h.nextHopProtocol,
      // @ts-expect-error - It's experimental so the type does not exist yet in TS https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
      lcpResourceDeliveryType: (m = e.lcpResourceEntry) == null ? void 0 : m.deliveryType
    }
  };
}, Lt = (i) => {
  const { value: t } = i;
  return {
    ttfb: Math.trunc(t),
    metadata: {}
  };
}, bt = (i) => {
  const { value: t } = i;
  return {
    fcp: Math.trunc(t),
    metadata: {}
  };
}, H = {
  INP: Et,
  CLS: St,
  LCP: Mt,
  TTFB: Lt,
  FCP: bt
};
function wt(i, t) {
  return H == null ? void 0 : H[i.name](i, t);
}
class Ct {
  constructor({
    url: t,
    platform: a,
    logger: e,
    pulseLogger: n,
    navigationId: r,
    navType: s,
    sessionId: u,
    vsi: o,
    msid: d,
    uuid: l,
    getHtmlElementMetadata: c
  }) {
    // Internal business logic
    g(this, "_map", /* @__PURE__ */ new Map());
    g(this, "_logger");
    g(this, "_pulseLogger");
    // Data added to the event
    g(this, "_navigationId");
    g(this, "_navType");
    g(this, "_url");
    g(this, "_platform");
    g(this, "_sessionId");
    g(this, "_vsi");
    g(this, "_msid");
    g(this, "_uuid");
    // Public properties
    g(this, "getHtmlElementMetadata", () => ({}));
    this._url = _t(t), this._platform = a, this._logger = e, this._pulseLogger = n, this._navigationId = r, this._navType = s, this._sessionId = u, this._vsi = o, this._msid = d, this._uuid = l, this.getHtmlElementMetadata = c;
  }
  flushQueue() {
    if (this._map.size > 0) {
      try {
        let t = {};
        const a = {};
        for (const [p, v] of this._map.entries()) {
          const { metadata: f, ...h } = v;
          f && (a[p] = f), t = {
            ...t,
            ...h
          };
        }
        const e = performance.getEntriesByType("long-animation-frame");
        a.loafs = e;
        const n = JSON.stringify(a), r = yt({
          platform: this._platform,
          url: this._url,
          navigationId: this._navigationId,
          navType: this._navType,
          ...t,
          metadata: n,
          sessionId: this._sessionId,
          ...this._msid && { msid: this._msid },
          ...this._vsi && { vsi: this._vsi },
          ...this._uuid && { uuid: this._uuid }
        }), { src: s, evid: u, params: o, ...d } = r, l = { src: s, evid: u, ...o }, c = { ...d, category: "essential" };
        this._logger.log(l, c), this._pulseLogger.info("Flushing queue", r);
      } catch (t) {
        this._pulseLogger.error("Failed to flush queue", t);
      }
      this._map.clear();
    }
  }
  addToQueue(t) {
    this._pulseLogger.info(`Adding metric to queue: ${t.name}`, t), this._map.set(
      t.name,
      wt(t, this.getHtmlElementMetadata)
    );
  }
}
function Rt(i) {
  return {
    info: (t, ...a) => {
      i && console.info(`[Pulse] ${t}`, a);
    },
    warn: (t, ...a) => {
      i && console.warn(`[Pulse] ${t}`, a);
    },
    error: (t, ...a) => {
      i && console.error(`[Pulse] ${t}`, a);
    }
  };
}
class At {
  constructor(t) {
    g(this, "_platform");
    g(this, "_logger");
    g(this, "_reportSoftNavs", !1);
    g(this, "_debug", !1);
    g(this, "_queues", /* @__PURE__ */ new Map());
    g(this, "_url", window.location.href);
    g(this, "_pulseLogger");
    g(this, "_sessionId");
    g(this, "_vsi");
    g(this, "_msid");
    g(this, "_uuid");
    g(this, "_getHtmlElementMetadata", () => ({}));
    this._platform = t.platform, this._logger = t.logger, this._reportSoftNavs = t.reportSoftNavs || !1, this._debug = t.debug || !1, this._sessionId = t.sessionId, this._vsi = t.vsi, this._msid = t.msid, this._uuid = t.uuid, t.getHtmlElementMetadata && (this._getHtmlElementMetadata = t.getHtmlElementMetadata);
    const a = new URLSearchParams(window.location.search);
    this._pulseLogger = Rt(
      this._debug || a.has("debugPulse")
    ), this._initListeners();
  }
  update({
    getHtmlElementMetadata: t
  }) {
    this._getHtmlElementMetadata = t;
    for (const a of this._queues.values())
      a.getHtmlElementMetadata = this._getHtmlElementMetadata;
  }
  addMetricToQueue(t) {
    var n;
    const { navigationId: a, navigationType: e } = t;
    this._queues.has(a.toString()) || this._queues.set(
      a.toString(),
      new Ct({
        url: this._url,
        platform: this._platform,
        logger: this._logger,
        pulseLogger: this._pulseLogger,
        sessionId: this._sessionId,
        ...this._vsi && { vsi: this._vsi },
        ...this._msid && { msid: this._msid },
        ...this._uuid && { uuid: this._uuid },
        getHtmlElementMetadata: this._getHtmlElementMetadata,
        navigationId: a.toString(),
        navType: e
      })
    ), (n = this._queues.get(a.toString())) == null || n.addToQueue(t);
  }
  _initListeners() {
    Tt((t) => this.addMetricToQueue(t), {
      reportSoftNavs: this._reportSoftNavs
    }), dt((t) => this.addMetricToQueue(t), {
      reportSoftNavs: this._reportSoftNavs
    }), pt((t) => this.addMetricToQueue(t), {
      reportSoftNavs: this._reportSoftNavs
    }), ct((t) => this.addMetricToQueue(t), {
      reportSoftNavs: this._reportSoftNavs
    }), gt((t) => this.addMetricToQueue(t), {
      reportSoftNavs: this._reportSoftNavs
    }), addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden")
        for (const t of this._queues.values())
          t.flushQueue();
    }), addEventListener("pagehide", () => {
      for (const t of this._queues.values())
        t.flushQueue();
    });
  }
}
export {
  At as Pulse
};
